module.exports = "<app-header *ngIf=\"showHeader\" color=\"red\" [addMenuTrigger]=\"true\" [brand]=\"headerTitle\" [actions]=\"headerActions\" [sidebarOpen]=\"sidebarOpen\" [backActive]=\"backActive\" (onSidebarToggle)=\"sidebarOpen = $event\" (onActionClicked)=\"onActionClicked($event)\" (onbackActionClicked)=\"onBackActionClicked()\"></app-header><my-sidenav [open]=\"sidebarOpen\"></my-sidenav><bw-background image=\"/img/backgrounds/main-background.png\"></bw-background><bw-overlay [opacity]=\"opacity\"></bw-overlay><section id=\"main-content\"><router-outlet></router-outlet></section>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.pug
// module id = 757
// module chunks = 0